import { http } from './config';

const SERVICE_PATH = 'services';

export default {
  solicitar: servico =>
    http.post(`${SERVICE_PATH}/request`, {
      service: servico,
      user: JSON.parse(localStorage.getItem('userData'))
    }),

  version: () => http.get(`${SERVICE_PATH}/version`)
};
